import { Box } from '@mui/material'
import React, { FormEvent, ReactNode } from 'react'

const contentMaxWidth = 1366

interface IFormRoot {
  children: ReactNode
  onHandleSubmit: (e: FormEvent<HTMLFormElement>) => void
}

const FormRoot: React.FC<IFormRoot> = ({ children, onHandleSubmit }) => {
  return (
    <Box
      noValidate
      component={'form'}
      data-testid="form-root"
      onSubmit={onHandleSubmit}
      sx={{
        width: "auto !important",
        maxWidth: contentMaxWidth,
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        padding: 0
      }}
    >
      {children}
    </Box>
  )
}

export default FormRoot